import { Field } from '@availity/form';
import React from 'react';
import { validatePercentageField } from '../../../../../utils/percentFieldValidator';

interface MarketplacePercentFieldProps {
    name: string;
    value: string | number;
    setValue: (name: string, value: string) => void;
}

export const MarketplacePercentField = (
    props: MarketplacePercentFieldProps
) => {
    return (
        <Field
            type="text"
            name={props.name}
            value={(props.value?.toString() ?? '0') + '%'}
            min={1}
            max={100}
            onKeyDown={(event) => {
                if (validatePercentageField(event, props.value?.toString() ?? '')) {
                    event.preventDefault();
                }
            }}
            onChange={(event) => {
                let value = event.target.value;

                if (
                    !event.target.value.includes('%') &&
                    Number(value) === Number(props.value)
                ) {
                    value = event.target.value.slice(0, -1);
                }
                const res = value.replace('%', '');
                props.setValue(props.name, res);
            }}></Field>
    );
};
